import { render, staticRenderFns } from "./Vinculargrupos.vue?vue&type=template&id=de3ba708"
import script from "./Vinculargrupos.vue?vue&type=script&lang=js"
export * from "./Vinculargrupos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Vinculargrupos.vue?vue&type=style&index=1&id=de3ba708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports